"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONTableRowPropertiesConverter = void 0;
var common_1 = require("@devexpress/utils/lib/utils/common");
var table_row_properties_1 = require("../../../tables/properties/table-row-properties");
var json_table_row_enums_1 = require("../../enums/table/json-table-row-enums");
var json_table_unit_converter_1 = require("./json-table-unit-converter");
var JSONTableRowPropertiesConverter = (function () {
    function JSONTableRowPropertiesConverter() {
    }
    JSONTableRowPropertiesConverter.convertFromJSON = function (obj) {
        var result = new table_row_properties_1.TableRowProperties();
        result.cellSpacing = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertFromJSON(obj[json_table_row_enums_1.JSONEnumTableRowProperty.CellSpacing]);
        result.header = !!obj[json_table_row_enums_1.JSONEnumTableRowProperty.Header];
        result.hideCellMark = !!obj[json_table_row_enums_1.JSONEnumTableRowProperty.HideCellMark];
        result.cantSplit = !!obj[json_table_row_enums_1.JSONEnumTableRowProperty.CantSplit];
        result.tableRowAlignment = obj[json_table_row_enums_1.JSONEnumTableRowProperty.TableRowAlignment];
        result.mask = obj[json_table_row_enums_1.JSONEnumTableRowProperty.UseValue];
        result.divId = obj[json_table_row_enums_1.JSONEnumTableRowProperty.DivId];
        return result;
    };
    JSONTableRowPropertiesConverter.convertToJSON = function (source) {
        var result = {};
        result[json_table_row_enums_1.JSONEnumTableRowProperty.CellSpacing] = json_table_unit_converter_1.JSONTableWidthUnitConverter.convertToJSON(source.cellSpacing);
        result[json_table_row_enums_1.JSONEnumTableRowProperty.Header] = common_1.boolToInt(source.header);
        result[json_table_row_enums_1.JSONEnumTableRowProperty.HideCellMark] = common_1.boolToInt(source.hideCellMark);
        result[json_table_row_enums_1.JSONEnumTableRowProperty.CantSplit] = common_1.boolToInt(source.cantSplit);
        result[json_table_row_enums_1.JSONEnumTableRowProperty.TableRowAlignment] = source.tableRowAlignment;
        result[json_table_row_enums_1.JSONEnumTableRowProperty.UseValue] = source.mask;
        result[json_table_row_enums_1.JSONEnumTableRowProperty.DivId] = source.divId;
        return result;
    };
    return JSONTableRowPropertiesConverter;
}());
exports.JSONTableRowPropertiesConverter = JSONTableRowPropertiesConverter;
